export const LENDER_OPTIONS = [
  'Amex',
  'Bank of America',
  'Chase',
  'TD Bank',
  'Elan Financial',
  'Capital One',
  'Citi',
  'Wells Fargo',
  'U.S. Bank',
  'Navy Federal',
  'Other',
  'Custom',
];

export const LENDING_PRODUCT_OPTIONS = [
  '0% Business Credit Card',
  '0% Personal Credit Card',
  'Personal Loan',
  'Personal Credit Card',
  'Non-Promo Business Credit Card',
  'Business Line of Credit',
  'Business Loan',
  'Term Loan',
  'SBA Loan',
  'Equipment Financing',
  'Revenue-Based Financing',
  'Other',
  'Custom',
];

export const APPLICATION_TYPE_OPTIONS = [
  'Business PG',
  'No PG',
  'Personal',
  'Business',
  'Full-doc',
  'Low-doc',
  'No-doc',
  'Stated Income',
  'Other',
  'Custom',
];

export const PERS_BIZ_OPTIONS = ['Unknown', 'Personal', 'Business', 'Both / PG', 'Custom'];

export const DECISION_OPTIONS = [
  'Approved',
  'Pending',
  'Denied',
  'Conditional Approval',
  'Counter Offer',
  'More Documents Requested',
  'Withdrawn',
  'Custom',
];

export const ZERO_PERCENT_TERM_OPTIONS = [
  'None',
  '6 months',
  '9 months',
  '12 months',
  '15 months',
  '18 months',
  '21 months',
  '24 months',
  'Custom',
];

export const TIME_YEARS_OPTIONS = [
  { value: 0, label: '0 years' },
  { value: 1, label: '1 year' },
  { value: 2, label: '2 years' },
  { value: 3, label: '3 years' },
  { value: 4, label: '4 years' },
  { value: 5, label: '5 years' },
  { value: 6, label: '6 years' },
  { value: 7, label: '7 years' },
  { value: 8, label: '8 years' },
  { value: 9, label: '9 years' },
  { value: 10, label: '10 years' },
  { value: 11, label: '11 years' },
  { value: 12, label: '12 years' },
  { value: 15, label: '15 years' },
  { value: 20, label: '20 years' },
  { value: 25, label: '25 years' },
  { value: 30, label: '30+ years' },
];

export const TIME_MONTHS_OPTIONS = Array.from({ length: 12 }, (_, i) => ({
  value: i,
  label: i === 1 ? '1 month' : `${i} months`,
}));

export const BUREAU_SCORE_OPTIONS = [300, 550, 600, 650, 680, 700, 720, 740, 760, 780, 800, 820, 850];

export const APPLICATION_HISTORY_COLUMNS = [
  { id: 'dateOfApplication', label: 'Date of Application', lockedVisible: true, reorderable: true, category: 'Application info' },
  { id: 'entity', label: 'Entity', lockedVisible: true, reorderable: true, category: 'Application info' },
  { id: 'applicants', label: 'Applicants', lockedVisible: true, reorderable: true, category: 'Application info' },
  { id: 'lender', label: 'Lender', lockedVisible: true, reorderable: true, category: 'Application info' },
  { id: 'lendingProduct', label: 'Lending Product', reorderable: true, category: 'Application info' },
  { id: 'applicationType', label: 'Type', reorderable: true, category: 'Application info' },
  { id: 'personalOrBusiness', label: 'Pers/Biz', reorderable: true, category: 'Application info' },
  { id: 'zeroPercentOffer', label: '0% Y/N', reorderable: true, category: 'Application info' },
  { id: 'approvalAmount', label: 'Approval Amount', reorderable: true, category: 'Application info' },
  { id: 'decision', label: 'Decision', reorderable: true, category: 'Application info' },
  { id: 'zeroPercentTerm', label: '0% Term', reorderable: true, category: 'Application info' },
  { id: 'bureauPull', label: 'Bureau Pull', reorderable: true, category: 'Application info' },
  { id: 'source', label: 'Source', reorderable: true, category: 'Application info' },
  { id: 'notes', label: 'Notes', reorderable: true, category: 'General info' },
  { id: 'actions', label: 'Actions', lockedVisible: true, reorderable: true, category: 'Application info' },
  { id: 'ownerName', label: 'Owner Name', reorderable: true, category: 'Contact' },
  { id: 'ssn', label: 'SSN', reorderable: true, category: 'Contact', sensitive: true },
  { id: 'dob', label: 'DOB', reorderable: true, category: 'Contact' },
  { id: 'fullEin', label: 'Full EIN', reorderable: true, category: 'Business info' },
  { id: 'businessStartDate', label: 'Business Start Date', reorderable: true, category: 'Business info' },
  { id: 'employerName', label: 'Employer', reorderable: true, category: 'General info' },
  { id: 'timeLiveInHouse', label: 'Time Live in House', reorderable: true, category: 'General info' },
  { id: 'timeWorkingAt', label: 'Time Working At', reorderable: true, category: 'General info' },
  { id: 'experianScoreUsed', label: 'Experian', reorderable: true, category: 'Bureau pull scores' },
  { id: 'transunionScoreUsed', label: 'TransUnion', reorderable: true, category: 'Bureau pull scores' },
  { id: 'equifaxScoreUsed', label: 'Equifax', reorderable: true, category: 'Bureau pull scores' },
  { id: 'personalIncome', label: 'Personal Income', reorderable: true, category: 'Income & assets' },
  { id: 'businessIncome', label: 'Business Income', reorderable: true, category: 'Income & assets' },
  { id: 'housing', label: 'Housing', reorderable: true, category: 'Income & assets' },
  { id: 'businessExpenses', label: 'Biz Expenses', reorderable: true, category: 'Income & assets' },
  { id: 'savings', label: 'Savings', reorderable: true, category: 'Income & assets' },
  { id: 'retirementAccount', label: 'Retirement Account', reorderable: true, category: 'Income & assets' },
  { id: 'personalAddress', label: 'Personal Address', reorderable: true, category: 'Contact' },
  { id: 'businessAddress', label: 'Business Address', reorderable: true, category: 'Business info' },
];

export const APPLICATION_HISTORY_DEFAULT_VISIBLE = [
  'dateOfApplication',
  'entity',
  'applicants',
  'lender',
  'lendingProduct',
  'applicationType',
  'personalOrBusiness',
  'zeroPercentOffer',
  'approvalAmount',
  'decision',
  'zeroPercentTerm',
  'bureauPull',
  'source',
  'notes',
  'actions',
];

export const DEFAULT_VISIBLE_COLUMNS = APPLICATION_HISTORY_DEFAULT_VISIBLE;
